import {
    COMPARADOR_LOAD_MODELS_BEGIN,
    COMPARADOR_LOAD_MODELS_FAILURE,
    COMPARADOR_LOAD_MODELS_SUCCESS
} from './constants'
import axios from 'axios'
import { getResponseMapped } from '../utils/utils'

export function loadModels(endpoint, inputValue, index) {
    return (dispatch) => {
        if (!endpoint || index === undefined) {
            return null
        }

        dispatch({ type: COMPARADOR_LOAD_MODELS_BEGIN })

        return new Promise((resolve, reject) => {
            const doRequest = axios.get(endpoint)
            doRequest.then(
                (res) => {
                    const responseData = getResponseMapped(res.data.data)
                    dispatch({
                        type: COMPARADOR_LOAD_MODELS_SUCCESS,
                        data: responseData,
                        index: index
                    })

                    let aux = res.data.data.filter((dataValue) => dataValue.name.includes(inputValue.toUpperCase()))
                    resolve(getResponseMapped(aux))
                },
                (err) => {
                    dispatch({
                        type: COMPARADOR_LOAD_MODELS_FAILURE,
                        data: { error: err },
                        index: index
                    })
                    reject(err)
                }
            )
        })
    }
}

export function reducer(state, action) {
    const { index, data, type } = action
    if (index === undefined) return state
    switch (type) {
        case COMPARADOR_LOAD_MODELS_BEGIN:
            return {
                ...state,
                models: {
                    ...state.models,
                    [`${index}`]: {
                        isPending: true,
                        hasError: null,
                        data: null
                    }
                }
            }

        case COMPARADOR_LOAD_MODELS_SUCCESS:
            return {
                ...state,
                models: {
                    ...state.models,
                    [`${index}`]: {
                        isPending: false,
                        hasError: null,
                        data: data
                    }
                }
            }

        case COMPARADOR_LOAD_MODELS_FAILURE:
            return {
                ...state,
                models: {
                    ...state.models,
                    [`${index}`]: {
                        isPending: false,
                        hasError: data.error,
                        data: null
                    }
                }
            }
        default:
            return state
    }
}

